import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import storePersist from '../../../../../../redux/storePersist';
import AccountCategoryComponent from '../components/account-category.component';
import { accountCategories } from '../../../../../../redux/account-categories/action';
import { selectAccountCategoriesListItems, selectAccountCategoriesQueryItems } from '../../../../../../redux/account-categories/selector';

const ManagementAccountCategory = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const accountCategoriesQueryData = useSelector(selectAccountCategoriesQueryItems)  
  const accountCategoriesItems = useSelector(selectAccountCategoriesListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectAccountCategories, setSelectAccountCategories] = useState<any>([])
  const librariesItems = storePersist?.get("library")?.current;

  const fetchCreditDebitNotesQueryById = () => {
    dispatch(accountCategories.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/account-categories/query`,
      entity: 'accountCategories',
      jsonData: {
        Records: [
          {
            Id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectAccountCategories({ ...selectAccountCategories, [field]: event })
  }

  useEffect(() => {
    dispatch(accountCategories.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/account-categories/list`,
      entity: 'accountCategories',
      jsonData: {}
    })).then(() => {
      if (parmas?.id > 0) {
        fetchCreditDebitNotesQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, []
  )

  useEffect(() => {
    if (isQuery) {
      setSelectAccountCategories(accountCategoriesQueryData?.result?.items)
    }
  }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(accountCategories.resetAction({ actionType: 'update' }))
      await dispatch(accountCategories.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/account-categories`,
        entity: 'accountCategories',
        jsonData: {
          Records: [
            selectAccountCategories
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(accountCategories.resetAction({ actionType: 'create' }))
      await dispatch(accountCategories.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/account-categories`,
        entity: 'accountCategories',
        jsonData: {
          Records: [
            selectAccountCategories
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/e-applications/accounts/account-categories')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <AccountCategoryComponent
          handleInnerFormChange={handleInnerFormChange}
          selectAccountCategories={selectAccountCategories}
          accountHeadsList={librariesItems?.AccountHead}
          accountCategoriesList={accountCategoriesItems?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )
}

export default ManagementAccountCategory;